// extracted by mini-css-extract-plugin
module.exports = {"soccerContainer":"Soccer_soccerContainer___Mb54","apaOuterFrame":"Soccer_apaOuterFrame__fKhAT"};